export default "__VITE_ASSET__DC_4Rak___"